/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_F1Inputs */

const en_mk_sol_operasional_f1 = /** @type {(inputs: Mk_Sol_Operasional_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 people across 3 operations teams`)
};

const id_mk_sol_operasional_f1 = /** @type {(inputs: Mk_Sol_Operasional_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20 orang di 3 tim operasional`)
};

/**
* | output |
* | --- |
* | "20 people across 3 operations teams" |
*
* @param {Mk_Sol_Operasional_F1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_f1 = /** @type {((inputs?: Mk_Sol_Operasional_F1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_F1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_f1(inputs)
	return en_mk_sol_operasional_f1(inputs)
});